<template>
	<TeamLayout
		:team-id="teamId"
	>
		<template #view="{ team, teamLoaded }">
			<main class="team-layout__tab-container">
				<router-view v-if="teamLoaded"
					:teamId="teamId"
					:team="team"
					:key="`${ teamId }.${ docType }`"
					v-bind="$attrs"
				/>
			</main>
		</template>
	</TeamLayout>
</template>

<script>
import TeamLayout from "./TeamLayout.vue";

export default {
	name: "TeamStreamLayout",
	components: {
		TeamLayout,
	},
	props: {
		teamId: {
			type: String,
			required: true,
		},
		docType: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="scss">
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	height: 100%;
}
</style>

<style lang="scss" scoped>
.team-layout__tab-container {
	@include auto-y-scroll();
	width: 100%;
	flex: 1;
	position: relative;
	display: flex;
	flex-direction: column;
}
</style>
